import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogIn, UserPlus, ArrowLeft, Store } from "lucide-react";

const PublicShell = ({ children }) => {
  const { user } = useAuth();
  // A merchant-specific store link (/store/:id) must never expose the general marketplace to that merchant's customers.
  const insideMerchantStore = useLocation().pathname.startsWith("/store/");
  let dashLink = null;
  if (user) {
    dashLink = user.role === "admin" ? "/admin" : "/dashboard";
  }

  return (
    <div className="min-h-screen bg-[#EBF4F6] flex flex-col" dir="rtl">
      <header className="sticky top-0 z-50 bg-white/85 backdrop-blur border-b border-[#7AB2B2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-lg bg-[#09637E] text-white flex items-center justify-center font-extrabold">إ</div>
            <span className="font-extrabold text-[#09637E] text-xl">إمداد</span>
          </Link>
          <nav className="flex items-center gap-2">
            {!insideMerchantStore && (
              <Link to="/stores" className="h-10 px-3 rounded-lg text-[#09637E] hover:bg-white font-bold text-sm flex items-center gap-1" data-testid="nav-browse-stores">
                <Store size={16} /> <span className="hidden sm:inline">تصفّح المتاجر</span><span className="sm:hidden">المتاجر</span>
              </Link>
            )}
            {dashLink ? (
              <Link to={dashLink} className="h-10 px-4 rounded-lg bg-[#09637E] hover:bg-[#088395] text-white font-bold text-sm flex items-center gap-1">
                لوحتي <ArrowLeft size={16} />
              </Link>
            ) : (
              <>
                <Link to="/login" className="h-10 px-4 rounded-lg border-2 border-[#09637E] text-[#09637E] hover:bg-white font-bold text-sm flex items-center gap-1">
                  <LogIn size={16} /> دخول
                </Link>
                <Link to="/register" className="h-10 px-4 rounded-lg bg-[#09637E] hover:bg-[#088395] text-white font-bold text-sm flex items-center gap-1">
                  <UserPlus size={16} /> سجل
                </Link>
              </>
            )}
          </nav>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="bg-[#09637E] text-white py-8 mt-10">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4 text-sm">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-lg bg-white/20 flex items-center justify-center font-extrabold">إ</div>
            <span className="font-extrabold">إمداد</span>
          </div>
          <nav className="flex items-center gap-1 sm:gap-3 flex-wrap justify-center">
            {!insideMerchantStore && <>
              <Link to="/stores" className="inline-flex items-center min-h-[44px] px-2 hover:underline opacity-90 hover:opacity-100" data-testid="footer-browse-stores">تصفّح المتاجر</Link>
              <span className="opacity-30">|</span>
            </>}
            <Link to="/about" className="inline-flex items-center min-h-[44px] px-2 hover:underline opacity-90 hover:opacity-100">عن المنصة</Link>
            <span className="opacity-30">|</span>
            <Link to="/contact" className="inline-flex items-center min-h-[44px] px-2 hover:underline opacity-90 hover:opacity-100">اتصل بنا</Link>
            <span className="opacity-30">|</span>
            <Link to="/terms" className="inline-flex items-center min-h-[44px] px-2 hover:underline opacity-90 hover:opacity-100">الشروط والأحكام</Link>
            <span className="opacity-30">|</span>
            <Link to="/privacy-policy" className="inline-flex items-center min-h-[44px] px-2 hover:underline opacity-90 hover:opacity-100" data-testid="footer-privacy-link">سياسة الخصوصية</Link>
          </nav>
          <div className="opacity-80">© 2026 إمداد - جميع الحقوق محفوظة</div>
        </div>
      </footer>
    </div>
  );
};

export default PublicShell;
